import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/footer-logo.png'


const _hoisted_1 = { class: "min-h-screen relative" }
const _hoisted_2 = {
  key: 0,
  class: "fixed top-0 left-0 flex justify-center items-center w-full h-full bg-modal z-50"
}
const _hoisted_3 = {
  key: 1,
  class: "fixed top-0 left-0 flex justify-center items-center w-full h-full bg-modal z-50"
}
const _hoisted_4 = { class: "flex w-full" }
const _hoisted_5 = { class: "flex flex-col justify-between min-w-48 mt-[76px] py-10 bg-neutral-100" }
const _hoisted_6 = { class: "self-center text-white" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("footer", { class: "self-end mt-auto mb-8" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.resrequest.com/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "footer logo",
      class: "w-[100px] h-8 opacity-75"
    })
  ])
], -1)

import { ref, onMounted, computed, watch } from "vue";
import { useStore } from 'vuex';
import axios from "axios";
import TopMenu from "../menus/TopMenu.vue";
import LeftMenu from "../menus/LeftMenu.vue";
import ToastPopup from "@/components/notifications/ToastPopup.vue";
import ClearCacheModal from "@/components/modals/ClearCacheModal.vue";
import UpdateWidgetModal from "../modals/UpdateWidgetModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const API_URL = process.env.VUE_APP_API;

const username = ref<string | null>(null);
const version = ref<string>('');

const getVersion = async () => {
  try {
    const { data } = await axios.get(`${API_URL}v3/fetchVersion`);
    version.value = data.version + '.' + data.build;
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  username.value = sessionStorage.getItem("username");
  await getVersion();
});

const toastText = ref<string>('');
const showClearCacheToast = ref<boolean>(false);
const isShowClearCacheModal = ref<boolean>(false);
const startClearCache = ref<boolean>(false);

const toggleClearCacheModal = (info: string) => {
  if (info !== undefined) {
    showClearCacheToast.value = true;
    toastText.value = info;
    setTimeout(() => { showClearCacheToast.value = false }, 3000);
  }

  isShowClearCacheModal.value = !isShowClearCacheModal.value;
}

const store = useStore();
const showUpdateWidgetModal = ref<boolean>(false);
const isSaveBtnVisible = computed(() => store.getters.getSaveBtnVisibility);

const handleClearCache = () => {
  startClearCache.value = true;
}

watch(() => [startClearCache.value, isSaveBtnVisible.value], ([valueOne, valueTwo]) => {
  if (valueOne && valueTwo) {
    showUpdateWidgetModal.value = true;
    startClearCache.value = false;
    return;
  }

  if (valueOne) {
    isShowClearCacheModal.value = true;
    startClearCache.value = false;
  }
});

const discardChanges = () => {
  showUpdateWidgetModal.value = false;
  isShowClearCacheModal.value = true;
}

const returnToEditing = () => {
  showUpdateWidgetModal.value = false;
  isShowClearCacheModal.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopMenu, {
      username: username.value,
      onInfo: handleClearCache
    }, null, 8, ["username"]),
    (isShowClearCacheModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ClearCacheModal, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (isShowClearCacheModal.value = false)),
            onClearCache: toggleClearCacheModal
          })
        ]))
      : _createCommentVNode("", true),
    (showUpdateWidgetModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(UpdateWidgetModal, {
            onDiscardChanges: discardChanges,
            onReturnToEditing: returnToEditing
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("aside", _hoisted_5, [
        _createVNode(LeftMenu),
        _createElementVNode("p", _hoisted_6, "Version " + _toDisplayString(version.value), 1)
      ]),
      _createElementVNode("main", {
        ref: "mainContainer",
        class: _normalizeClass(["flex flex-col w-full mt-[76px] px-8 pt-8 bg-neutral-0 overflow-y-scroll scroll-smooth", isShowClearCacheModal.value ? '!overflow-y-hidden' : 'overflow-auto']),
        style: {"height":"calc(100vh - 76px)"}
      }, [
        (showClearCacheToast.value)
          ? (_openBlock(), _createBlock(ToastPopup, {
              key: 0,
              status: "success",
              text: toastText.value,
              width: 300,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (showClearCacheToast.value = false))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_view),
        _hoisted_7
      ], 2)
    ])
  ]))
}
}

})